module.exports = __webpack_public_path__ + "2869231d87282ea326e7c9d4826d6c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bgr_6.jpg
// module id = 834
// module chunks = 0